import { Component, OnInit } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { AuthService } from '../../services/auth.service'
import { ILoginRequest } from '../../model/interfaces'
import { catchError, of } from 'rxjs'
import { HttpErrorResponse } from '@angular/common/http'

import { NzAlertComponent } from 'ng-zorro-antd/alert'
import { NzCardComponent } from 'ng-zorro-antd/card'
import { NzFormControlComponent, NzFormDirective } from 'ng-zorro-antd/form'
import { NzColDirective } from 'ng-zorro-antd/grid'
import { NzInputDirective } from 'ng-zorro-antd/input'
import { NzIconDirective } from 'ng-zorro-antd/icon'
import { ɵNzTransitionPatchDirective } from 'ng-zorro-antd/core/transition-patch'
import { NzButtonComponent } from 'ng-zorro-antd/button'
import { NzWaveDirective } from 'ng-zorro-antd/core/wave'
import { NzTypographyComponent } from 'ng-zorro-antd/typography'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass'],
  imports: [
    NzAlertComponent,
    NzCardComponent,
    FormsModule,
    NzFormDirective,
    ReactiveFormsModule,
    NzColDirective,
    NzFormControlComponent,
    NzInputDirective,
    NzIconDirective,
    ɵNzTransitionPatchDirective,
    NzButtonComponent,
    NzWaveDirective,
    NzTypographyComponent,
  ],
})
export class LoginComponent implements OnInit {
  form!: UntypedFormGroup
  data!: ILoginRequest
  submitted = false
  message!: { type: 'success' | 'info' | 'warning' | 'error'; text: string }
  passwordVisible = false
  otpVisible = false
  error?: HttpErrorResponse
  get errorText(): string {
    return [401, 400].includes(this.error?.status || 0) ? 'Логин или пароль указаны неверно' : this.error?.message || ''
  }
  constructor(private fb: UntypedFormBuilder, private authService: AuthService, private router: Router) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      login: [null, [Validators.required]],
      password: [null, [Validators.required]],
    })
  }

  submitForm(): void {
    if (this.submitted) {
      return
    }
    this.submitted = true
    const { login, password } = { ...this.form.value }
    if (this.form.valid) {
      this.data = { login, password }
    }
    this.authService
      .login(this.data)
      .pipe(
        catchError(error => {
          this.submitted = false
          this.error = error
          return of(null)
        })
      )
      .subscribe(loginResponse => {
        if (loginResponse) {
          this.form.reset()
          this.router.navigate([this.authService.redirectUrl ? this.authService.redirectUrl : '/']).then()
          this.submitted = false
        }
      })
  }
}
